import {ModbusSignal} from '@models/adminstration/gateway/gateway-configuration/modbus-signal';

export class ModbusRegister {
  address: number = 0;
  signals: ModbusSignal[] = [];
}